import JSZip from "jszip";
import { ajax } from "../../utils/async";
import { ERR_INVALID_ARGUMENT } from "../../utils/error";
import { isNullOrEmpty, isString } from "../../utils/string";
import { FileNotFoundError } from "./Types";
export class ZipDocumentContainer {
    static NewContainer() {
        return (new ZipDocumentContainer(new JSZip()));
    }
    static LoadContainer(pData) {
        const tZip = new JSZip();
        const tPromise = tZip.loadAsync(pData).then(() => {
            return (new ZipDocumentContainer(tZip));
        }).catch((pError) => {
            return (Promise.reject(new Error("Failed to read zip: " + pError)));
        });
        return (tPromise);
    }
    addFile(pData, pFilename, pCompress, pCacheable) {
        if (pData == null || isNullOrEmpty(pFilename))
            return (Promise.reject(new Error(ERR_INVALID_ARGUMENT)));
        const tOptions = {};
        tOptions.binary = !isString(pData);
        if (pCompress != null && pCompress === false) {
            tOptions.compression = "STORE";
        }
        this.mZip.file(pFilename, pData, tOptions);
        return (Promise.resolve());
    }
    addFileFromUrl(pUrl, pFilename, pBinary, pCompress, pCacheable) {
        if (isNullOrEmpty(pUrl) || isNullOrEmpty(pFilename))
            return (Promise.reject(new Error(ERR_INVALID_ARGUMENT)));
        const tPromise = ajax("GET", pUrl, null, {
            responseType: pBinary ? "arraybuffer" : "text"
        }).then((pResponse) => {
            return (this.addFile(pResponse, pFilename, pCompress));
        });
        return (tPromise);
    }
    addFileFromCache(pFilename, pCompress) {
        return (Promise.resolve(false));
    }
    getFile(pFilename, pBinary) {
        const tZipFile = this.mZip.file(pFilename);
        if (tZipFile == null)
            return (Promise.reject(new FileNotFoundError(pFilename)));
        return (tZipFile.async(pBinary ? "arraybuffer" : "string"));
    }
    listFiles(pFolderPath) {
        const tZipFolder = pFolderPath != null ? this.mZip.folder(pFolderPath) : this.mZip;
        if (tZipFolder == null)
            return (Promise.reject(new FileNotFoundError(pFolderPath)));
        const tFiles = new Array();
        tZipFolder.forEach((pPath, pFile) => {
            if (!pFile.dir)
                tFiles.push(pPath);
        });
        return (Promise.resolve(tFiles));
    }
    generateZip(pProgressCallback) {
        const tPromise = this.mZip.generateAsync({
            compression: this.compressionLevel === 0 ? "STORE" : "DEFLATE",
            compressionOptions: { level: this.compressionLevel },
            streamFiles: true,
            type: "arraybuffer"
        }, (pData) => {
            if (pProgressCallback != null)
                pProgressCallback(pData.percent);
        });
        return (tPromise);
    }
    constructor(pZip, pCompressionLevel = 4) {
        this.mZip = pZip;
        this.compressionLevel = pCompressionLevel;
    }
}
